import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import _ from 'lodash';
import { ToastModule } from 'primeng/toast';
import { AuthService } from '../../services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { LogService } from '../../services/log.service';
import { PasswordModule } from 'primeng/password';

@Component({
  selector: 'app-login',
  imports: [
    CardModule,
    InputTextModule,
    ButtonModule,
    TranslateModule,
    ReactiveFormsModule,
    ToastModule,
    CommonModule,
    PasswordModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private readonly destroy$ = inject(DestroyRef);
  public loginForm!: FormGroup;

  get fLogin(): { [index: string]: any } {
    return this.loginForm.controls;
  }

  constructor(
    private authService: AuthService,
    private cookieService: CookieService,
    private formBuilder: FormBuilder,
    private logService: LogService,
    private router: Router,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.loadLoginForm();
  }

  private loadLoginForm(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  public login(): void {
    this.loginForm?.markAllAsTouched();
    if(this.loginForm?.valid) {
      this.authService.login(this.loginForm.value).pipe(takeUntilDestroyed(this.destroy$)).subscribe({
        next: (res) => {
          // set token cookie
          this.cookieService.set('token', _.get(res, 'body.data')!, {path: '/'});
          setTimeout(() => {
            this.router.navigate(['admin', 'tournaments', 'active']);
          });
        },
        error: (err) => {
          this.logService.error('[Login] - login', err, this.translate.instant('error.login'));
        }
      });
    } else {
      this.logService.warn('[Login] - login', 'Missing Fields', this.translate.instant('error.missing-fields'));
    }
  }
}
